import React from 'react';
import styles from '../../styles/ConceptosCobroStyles/ConceptosCobro.module.css';

function StatusBadge({ status }) {
  const getStatusClass = (status) => {
    switch (status) {
      case 'ACTIVO':
        return styles.statusActive;
      case 'INACTIVO':
        return styles.statusInactive;
      default:
        return styles.statusDefault;
    }
  };

  return (
    <span className={`${styles.statusBadge} ${getStatusClass(status)}`}>
      {status}
    </span>
  );
}

export default StatusBadge;
